export const GLOSSARY = [
  {
    "key": 1,
    "value": "ABAC (attribute-based access control)",
    "description": "An authorization method that grants permissions based on user attributes, resource characteristics, and environmental context."
  },
  {
    "key": 2,
    "value": "Access controls",
    "description": "A set of authentication and authorization measures that determine who can interact with an AI system and what actions are permitted."
  },
  {
    "key": 3,
    "value": "Accountability (responsible AI)",
    "description": "The principle that clearly identifies who is responsible for AI outcomes, decisions, monitoring, and remediation."
  },
  {
    "key": 4,
    "value": "Accuracy auditing",
    "description": "A retrospective review that evaluates whether AI outputs are correct, complete, and aligned with ground-truth data or trusted sources."
  },
  {
    "key": 5,
    "value": "Adaptive network defense",
    "description": "A reinforcement learning approach in which an agent learns to modify network configurations or defensive actions based on rewards and penalties during simulated attacks."
  },
  {
    "key": 6,
    "value": "Adversarial example",
    "description": "An input intentionally modified in subtle ways to cause a model to produce an incorrect prediction. See also: Adversarial patch."
  },
  {
    "key": 7,
    "value": "Adversarial patch",
    "description": "A small visual modification such as a sticker crafted to cause computervision models to misclassify objects."
  },
  {
    "key": 8,
    "value": "Adversarial robustness",
    "description": "A model’s ability to resist or withstand adversarial examples and other manipulation attempts."
  },
  {
    "key": 9,
    "value": "Adversarial training",
    "description": "A defensive method that trains a model on adversarial examples so it can better recognize and resist manipulated inputs."
  },
  {
    "key": 10,
    "value": "Agent (reinforcement learning)",
    "description": "The decision-making component in a reinforcement learning system that takes actions within an environment to maximize cumulative rewards."
  },
  {
    "key": 11,
    "value": "Agent access controls",
    "description": "Restrictions placed on AI agents that limit which tools, APIs, or data sources an agent can use."
  },
  {
    "key": 12,
    "value": "AI (artificial intelligence)",
    "description": "A broad field of computer science focused on creating systems that perform tasks associated with human intelligence such as reasoning, learning, and decision-making."
  },
  {
    "key": 13,
    "value": "AI agent",
    "description": "A software-based system that independently perceives information, reasons about it, and takes actions, potentially over time, within defined goals and constraints, without continuous human direction."
  },
  {
    "key": 14,
    "value": "AI auditor",
    "description": "An independent reviewer who verifies alignment with policy, compliance requirements, and documented evidence throughout the AI life cycle."
  },
  {
    "key": 15,
    "value": "AI Center of Excellence (CoE)",
    "description": "A centralized group that sets AI standards, manages shared platforms, reviews use cases, and guides teams through governance."
  },
  {
    "key": 16,
    "value": "AI-enabled automation",
    "description": "The use of machine learning and orchestration to execute security tasks such as ticket creation, change approvals, and incident response with minimal human input."
  },
  {
    "key": 17,
    "value": "AI-enhanced DDoS",
    "description": "A distributed denial-of-service attack in which botnets use machinelearning models to adjust packet types, ports, and timing dynamically during the attack. See also: DDoS."
  },
  {
    "key": 18,
    "value": "AI FinOps (Financial Operations)",
    "description": "The practice of monitoring and managing AI-related costs, including token usage, compute consumption, and third-party API charges."
  },
  {
    "key": 19,
    "value": "AI-generated payload",
    "description": "Malicious code produced or refined by a generative model, often with built-in obfuscation or anti-analysis features."
  },
  {
    "key": 20,
    "value": "AI governance",
    "description": "The structure of rules, decision rights, controls, and oversight mechanisms that guide safe and compliant AI development and use."
  },
  {
    "key": 21,
    "value": "AI governance engineer",
    "description": "A role that translates policy into automated platform controls, approval workflows, and evidence collection."
  },
  {
    "key": 22,
    "value": "AI life cycle",
    "description": "The series of stages involved in developing, deploying, and maintaining an AI system, including planning, data collection, preparation, model development, evaluation, deployment, and monitoring."
  },
  {
    "key": 23,
    "value": "AI personal assistant",
    "description": "A conversational tool that supports communication and coordination tasks such as drafting updates, summarizing incidents, and managing workflow actions."
  },
  {
    "key": 24,
    "value": "AI risk analyst",
    "description": "A role responsible for assessing risks of AI use cases, performing impact assessments, scoring risk, and tracking mitigation plans."
  },
  {
    "key": 25,
    "value": "AI security architect",
    "description": "A role that performs AI-specific threat modeling and designs security controls for risks such as prompt injection and model theft."
  },
  {
    "key": 26,
    "value": "AI supply chain attack",
    "description": "A compromise that enters an AI system through external dependencies such as pretrained models, datasets, libraries, or third-party services."
  },
  {
    "key": 27,
    "value": "Anomaly detection",
    "description": "A technique used to identify data points or behaviors that deviate from normal patterns, often leveraging unsupervised learning to reveal unknown threats."
  },
  {
    "key": 28,
    "value": "Anonymization",
    "description": "A data protection method that irreversibly removes or alters identifiers so individuals cannot be reidentified."
  },
  {
    "key": 29,
    "value": "API (application programming interface)",
    "description": "A defined interface that allows software systems to communicate by sending requests and receiving structured responses."
  },
  {
    "key": 30,
    "value": "API key authentication",
    "description": "A mechanism that requires a unique key for accessing an AI API or service endpoint."
  },
  {
    "key": 31,
    "value": "Assistant role",
    "description": "The model-generated response within a conversational AI framework that can also be used as an example in few-shot prompts to guide model behavior. See also: Prompt roles."
  },
  {
    "key": 32,
    "value": "ATLAS (Adversarial Threat Landscape for Artificial-Intelligence Systems)",
    "description": "A MITRE-developed threat-intelligence framework that catalogs tactics, techniques, and procedures used to attack AI systems."
  },
  {
    "key": 33,
    "value": "Audit logging",
    "description": "The recording of system interactions, requests, and outputs to support monitoring, accountability, and incident review."
  },
  {
    "key": 34,
    "value": "Audit trail",
    "description": "A chronological record of system events and user actions that supports investigation, compliance, and traceability."
  },
  {
    "key": 35,
    "value": "Auditing for bias and fairness",
    "description": "The evaluation of AI outputs and behavior to detect unfair, discriminatory, or imbalanced outcomes across demographic or subgroup populations."
  },
  {
    "key": 36,
    "value": "Auditing for hallucinations",
    "description": "A review process that identifies fabricated or unsupported AI outputs through sampling, verification, and fact-checking."
  },
  {
    "key": 37,
    "value": "Auditing for security compliance",
    "description": "A structured evaluation that verifies enforcement of access controls, authentication, least privilege, segregation of duties, and data protection requirements."
  },
  {
    "key": 38,
    "value": "Automated attack generation",
    "description": "The use of AI agents to chain vulnerability scanning, exploit selection, payload crafting, and execution without human input."
  },
  {
    "key": 39,
    "value": "Automated data correlation",
    "description": "The use of AI to analyze leaked credentials, OSINT, system data, and social-media information to identify exploitable accounts or attack paths."
  },
  {
    "key": 40,
    "value": "Automated deployment",
    "description": "A CI/CD process where AI releases code to production, monitors for abnormal behavior, and may roll back changes automatically."
  },
  {
    "key": 41,
    "value": "Automated penetration testing",
    "description": "The use of AI tools to map applications, simulate attacks, and identify weaknesses without manual human testing."
  },
  {
    "key": 42,
    "value": "Automated reconnaissance",
    "description": "AI-driven discovery of targets, credentials, infrastructure, or vulnerabilities by summarizing large quantities of open source data."
  },
  {
    "key": 43,
    "value": "Autonomous system (AI)",
    "description": "A software or physical system that senses, decides, and acts without human approval on every step, which increases efficiency and risk."
  },
  {
    "key": 44,
    "value": "Backdoor attack",
    "description": "An attack in which an adversary implants hidden behavior into an AI model so it behaves normally in typical use but produces unauthorized or attacker-chosen behavior when a specific trigger is present."
  },
  {
    "key": 45,
    "value": "Backdoor trigger",
    "description": "A hidden pattern, phrase, or token embedded into a model during training that activates unauthorized or unintended behavior."
  },
  {
    "key": 46,
    "value": "Balancing (data balancing)",
    "description": "Techniques that adjust uneven class distributions in training data through oversampling, undersampling, or synthetic sample generation."
  },
  {
    "key": 47,
    "value": "Bias (AI risk)",
    "description": "Systematic and unfair differences in outcomes caused by skewed data, labels, or model design."
  },
  {
    "key": 48,
    "value": "Bias audit",
    "description": "A fairness assessment that tests model behavior across demographic groups and identifies systemic disparities in performance or outcomes."
  },
  {
    "key": 49,
    "value": "Bias introduction",
    "description": "The manipulation of a model’s behavior by injecting biased data or inputs that distort future predictions."
  },
  {
    "key": 50,
    "value": "BlackMamba",
    "description": "A proof-of-concept polymorphic malware that retrieves malicious code from an LLM at runtime, which makes static signature detection ineffective."
  },
  {
    "key": 51,
    "value": "Botnet controller (AI-assisted)",
    "description": "A DDoS command system that uses machine learning to adapt attack patterns in real time."
  },
  {
    "key": 52,
    "value": "Calibration fairness check",
    "description": "A fairness test that verifies whether predicted probabilities reflect actual outcomes equally across groups."
  },
  {
    "key": 53,
    "value": "Canary string",
    "description": "A unique identifier intentionally embedded in training data to test whether a model leaks sensitive content."
  },
  {
    "key": 54,
    "value": "CDN (content delivery network)",
    "description": "A distributed infrastructure that delivers content to users based on geographic proximity to improve performance and availability."
  },
  {
    "key": 55,
    "value": "CEF (Common Event Format)",
    "description": "A standardized log format used to structure security event data so tools can parse, normalize, and correlate alerts consistently."
  },
  {
    "key": 56,
    "value": "Chain-of-thought interference",
    "description": "An output integrity technique where intermediate model outputs in a multistep pipeline are altered to influence final responses."
  },
  {
    "key": 57,
    "value": "Change management automation",
    "description": "The use of AI to evaluate proposed changes, auto-approve routine updates, and monitor deployments for negative impacts."
  },
  {
    "key": 58,
    "value": "Chatbot",
    "description": "A natural-language interface that allows analysts to query security data, run investigations, and generate playbooks using conversational prompts."
  },
  {
    "key": 59,
    "value": "Checksums",
    "description": "Numerical values generated from data to detect unauthorized modifications and preserve data integrity."
  },
  {
    "key": 60,
    "value": "CI/CD (Continuous Integration and Continuous Deployment)",
    "description": "A development practice that automates code integration, testing, and deployment to production."
  },
  {
    "key": 61,
    "value": "Class imbalance",
    "description": "A condition where one class appears far more frequently than others in a dataset, which can lead to biased or inaccurate model predictions."
  },
  {
    "key": 62,
    "value": "Circuit breaker",
    "description": "A resilience control that temporarily disables request processing when system load becomes unstable or excessive."
  },
  {
    "key": 63,
    "value": "Classification",
    "description": "A supervised learning task that predicts categorical values."
  },
  {
    "key": 64,
    "value": "Classification labeling (data classification labeling)",
    "description": "The labeling of data according to sensitivity level to guide handling, storage, and access policies."
  },
  {
    "key": 65,
    "value": "CLI (command-line interface)",
    "description": "A text-based interface used to execute commands and interact with software or systems."
  },
  {
    "key": 66,
    "value": "CLI plug-in (AI-enabled)",
    "description": "A command-line extension that summarizes logs, interprets scan outputs, and generates actions directly from terminal commands."
  },
  {
    "key": 67,
    "value": "Clustering",
    "description": "An unsupervised learning technique that groups similar data points to identify patterns or detect anomalies without labeled examples."
  },
  {
    "key": 68,
    "value": "Code quality and linting (AI-assisted)",
    "description": "Tools that detect risky code, hardcoded secrets, outdated libraries, and insecure patterns in real time as developers type."
  },
  {
    "key": 69,
    "value": "Code scanning",
    "description": "Context-aware code analysis that identifies vulnerabilities, insecure functions, and bad patterns during development."
  },
  {
    "key": 70,
    "value": "Completeness auditing",
    "description": "A review that checks whether AI responses fully address the user’s question or task."
  },
  {
    "key": 71,
    "value": "Compensating controls",
    "description": "Additional defensive measures such as prompt firewalls or guardrails used to strengthen AI systems against threats that core architecture does not fully prevent."
  },
  {
    "key": 72,
    "value": "Concept drift",
    "description": "A change in underlying or real-world data patterns over time that reduces model accuracy unless the model is updated."
  },
  {
    "key": 73,
    "value": "Confidential computing",
    "description": "A technique that processes encrypted data within hardware-based secure enclaves so that data remains protected even in memory."
  },
  {
    "key": 74,
    "value": "Confidentiality leak (prompt leakage)",
    "description": "The unintended disclosure of internal system prompts or contextual instructions by an AI model."
  },
  {
    "key": 75,
    "value": "Conformity assessment (EU AI Act)",
    "description": "The required documentation, evaluation, and testing process for high-risk systems before they can enter the European Union market."
  },
  {
    "key": 76,
    "value": "Consistency (responsible AI)",
    "description": "The assurance that an AI system behaves predictably across time, versions, and contexts."
  },
  {
    "key": 77,
    "value": "Constrained output formatting",
    "description": "A guardrail that restricts the structure or format of model outputs, which reduces the chance of malicious or unsafe content."
  },
  {
    "key": 78,
    "value": "Containerization",
    "description": "Packaging an AI model and its supporting environment into an isolated container to improve portability and security."
  },
  {
    "key": 79,
    "value": "Content filter bypass",
    "description": "A technique that manipulates application integrations or output paths to circumvent safety filters."
  },
  {
    "key": 80,
    "value": "Content filtering",
    "description": "Rules or models that detect and block unwanted or unsafe content in model inputs or outputs."
  },
  {
    "key": 81,
    "value": "Content moderation (AI-powered)",
    "description": "The use of a secondary AI model to detect and filter harmful or noncompliant content in inputs or outputs."
  },
  {
    "key": 82,
    "value": "Continuous monitoring",
    "description": "The ongoing observation of model behavior, inputs, and outputs to detect drift, attacks, or performance degradation."
  },
  {
    "key": 83,
    "value": "Corporate AI policy",
    "description": "A set of mandated rules that define acceptable use, data handling, tool approval, and operational boundaries for AI systems."
  },
  {
    "key": 84,
    "value": "Cost monitoring",
    "description": "The ongoing tracking of AI expenses, including tokens, compute usage, storage, and external API calls."
  },
  {
    "key": 85,
    "value": "CPU (central processing unit)",
    "description": "The primary processing component of a computer responsible for executing instructions."
  },
  {
    "key": 86,
    "value": "Credential-stuffing automation",
    "description": "The use of generative or agent-based AI tools to test large volumes of leaked credentials against many services at machine speed."
  },
  {
    "key": 87,
    "value": "CRM (customer relationship management)",
    "description": "A system used to manage customer interactions, sales pipelines, and support operations."
  },
  {
    "key": 88,
    "value": "CVE (Common Vulnerabilities and Exposures)",
    "description": "A standardized identifier used to track publicly known cybersecurity vulnerabilities."
  },
  {
    "key": 89,
    "value": "CWE (Common Weakness Enumeration)",
    "description": "A community-developed list of common software security weaknesses used for assessment and remediation."
  },
  {
    "key": 90,
    "value": "DAST (Dynamic Application Security Testing)",
    "description": "A testing method that analyzes running applications to detect vulnerabilities during execution."
  },
  {
    "key": 91,
    "value": "Data augmentation",
    "description": "The creation of new synthetic data from existing examples to increase dataset diversity and reduce overfitting."
  },
  {
    "key": 92,
    "value": "Data cleansing",
    "description": "The removal of errors, inconsistencies, and irrelevant values from a dataset to improve quality and reliability."
  },
  {
    "key": 93,
    "value": "Data drift",
    "description": "A change in input data patterns over time that reduces model accuracy."
  },
  {
    "key": 94,
    "value": "Data encryption at rest",
    "description": "Encryption applied to stored data such as training datasets, logs, or model artifacts."
  },
  {
    "key": 95,
    "value": "Data encryption in transit",
    "description": "Encryption applied to data transmitted across networks to prevent interception or tampering."
  },
  {
    "key": 96,
    "value": "Data encryption in use",
    "description": "Techniques such as confidential computing or homomorphic encryption that protect data while it is being processed."
  },
  {
    "key": 97,
    "value": "Data engineer",
    "description": "A role responsible for building and maintaining data pipelines, feature stores, and lineage tracking while applying privacy and access controls."
  },
  {
    "key": 98,
    "value": "Data ingestion",
    "description": "The collection and import of data from various sources for use in an AI development pipeline."
  },
  {
    "key": 99,
    "value": "Data integrity",
    "description": "The assurance that data remains accurate, consistent, and unaltered throughout its life cycle."
  },
  {
    "key": 100,
    "value": "Data intake checklist",
    "description": "A structured review used to assess the quality, trustworthiness, and compliance of a dataset before it enters the pipeline."
  },
  {
    "key": 101,
    "value": "Data leakage",
    "description": "The unintended exposure of sensitive or internal data through prompts, training sets, indexes, or generated outputs."
  },
  {
    "key": 102,
    "value": "Data lineage",
    "description": "A record of where data originated and how it changed as it moved through the AI pipeline."
  },
  {
    "key": 103,
    "value": "Data masking",
    "description": "The replacement of sensitive values with realistic but fictitious substitutes to preserve utility while protecting privacy."
  },
  {
    "key": 104,
    "value": "Data minimization",
    "description": "A principle that limits the collection, retention, and use of data to only what is necessary for an intended purpose."
  },
  {
    "key": 105,
    "value": "Data poisoning",
    "description": "The introduction of corrupted, mislabeled, or adversarial data into training or fine-tuning pipelines to influence model behavior."
  },
  {
    "key": 106,
    "value": "Data provenance",
    "description": "Documentation that verifies the origin, trustworthiness, and authenticity of data used in AI systems."
  },
  {
    "key": 107,
    "value": "Data redaction",
    "description": "The removal or obscuring of sensitive information before storage, processing, or output."
  },
  {
    "key": 108,
    "value": "Data sanitization",
    "description": "The removal, masking, or tokenization of sensitive information before modeling."
  },
  {
    "key": 109,
    "value": "Data summarization (AI-powered)",
    "description": "Condensing long reports, logs, or advisories into short, actionable explanations."
  },
  {
    "key": 110,
    "value": "Dataset diversity",
    "description": "The inclusion of varied examples that help models perform reliably across different populations and conditions."
  },
  {
    "key": 111,
    "value": "Dataset versioning",
    "description": "Tracking updates to datasets to maintain lineage, reproducibility, and auditability."
  },
  {
    "key": 112,
    "value": "Decision rights",
    "description": "Assigned authority over key governance decisions such as approvals, risk escalation, and deployment sign-off."
  },
  {
    "key": 113,
    "value": "DDoS (distributed denial-of-service)",
    "description": "An attack in which many coordinated systems flood a target with traffic or requests to overwhelm its resources and disrupt normal service. See also: DoS (denial-of-service)."
  },
  {
    "key": 114,
    "value": "Deep learning",
    "description": "A subset of machine learning that uses multilayer neural networks to learn complex representations from raw data without manual feature engineering."
  },
  {
    "key": 115,
    "value": "Deep neural network",
    "description": "A type of neural network with multiple hidden layers that can capture complex patterns in data."
  },
  {
    "key": 116,
    "value": "Deepfake",
    "description": "Hyper-realistic AI-generated video or audio depicting someone saying or doing things they never actually did."
  },
  {
    "key": 117,
    "value": "Deepfake impersonation",
    "description": "The use of synthetic media to convincingly mimic a person’s identity in video or audio for fraud, malware delivery, or social engineering."
  },
  {
    "key": 118,
    "value": "Demographic parity",
    "description": "A fairness criterion requiring that different demographic groups receive similar outcomes."
  },
  {
    "key": 119,
    "value": "Dimensionality reduction",
    "description": "A process that simplifies high-dimensional data while preserving key patterns. See also: PCA."
  },
  {
    "key": 120,
    "value": "Digital signature (log integrity)",
    "description": "A cryptographic mechanism that makes log tampering detectable by verifying the authenticity of entries."
  },
  {
    "key": 121,
    "value": "Direct prompt injection",
    "description": "A prompt injection method where malicious instructions are placed directly in user input."
  },
  {
    "key": 122,
    "value": "Disinformation",
    "description": "Fabricated or manipulated content spread intentionally to influence opinions or decisions."
  },
  {
    "key": 123,
    "value": "Discriminator (GAN)",
    "description": "The model in a generative adversarial network that learns to distinguish real data from synthetic data during training."
  },
  {
    "key": 124,
    "value": "DLP (data loss prevention)",
    "description": "Tools and policies that detect and block unauthorized transmission or exposure of sensitive data."
  },
  {
    "key": 125,
    "value": "Document synthesis",
    "description": "The AI-driven consolidation of multiple documents into a single coherent summary that highlights key risks or findings."
  },
  {
    "key": 126,
    "value": "DoS (denial-of-service)",
    "description": "An attack that overwhelms an AI system with complex or resource-heavy queries to degrade performance or availability. See also: DDoS (distributed denial-of-service)."
  },
  {
    "key": 127,
    "value": "Dynamic malware generation",
    "description": "Producing new malicious code variants on demand so that each execution evades signature-based detection."
  },
  {
    "key": 128,
    "value": "EDR (endpoint detection and response)",
    "description": "A security solution that monitors endpoints to detect and respond to threats."
  },
  {
    "key": 129,
    "value": "Embedding",
    "description": "A numerical vector representation of data used to compare semantic similarity in RAG systems."
  },
  {
    "key": 130,
    "value": "Embedding weakness",
    "description": "A flaw in vector representations that allows malicious content to manipulate semantic similarity or inject poisoned vectors."
  },
  {
    "key": 131,
    "value": "Encryption (data encryption)",
    "description": "A method of protecting data by converting it into an unreadable form unless decrypted with authorized keys."
  },
  {
    "key": 132,
    "value": "Endpoint access controls",
    "description": "Security measures that restrict access to AI service endpoints using authentication, authorization, and network controls."
  },
  {
    "key": 133,
    "value": "ETL (extract, transform, load)",
    "description": "A data pipeline process used to collect, clean, and load data into storage or analytics systems."
  },
  {
    "key": 134,
    "value": "Equal opportunity",
    "description": "A fairness measure ensuring that equally qualified groups have an equal chance of receiving favorable model outcomes."
  },
  {
    "key": 135,
    "value": "Equalized odds",
    "description": "A fairness standard that requires error rates such as false positives and false negatives to be similar across groups."
  },
  {
    "key": 136,
    "value": "EU (European Union)",
    "description": "A political and economic union of member states in Europe that develop laws and regulatory standards including AI policy."
  },
  {
    "key": 137,
    "value": "Evaluation dataset",
    "description": "A dataset with known correct answers used for periodic accuracy and drift auditing."
  },
  {
    "key": 138,
    "value": "Evidence register",
    "description": "Documentation that records decisions, evaluations, mitigations, and approvals across the AI life cycle."
  },
  {
    "key": 139,
    "value": "Excessive agency",
    "description": "A condition where an AI system is given too much autonomy to make or execute high-impact actions without proper oversight."
  },
  {
    "key": 140,
    "value": "Explainability",
    "description": "The ability to provide meaningful insight into how an AI system produced its output, tailored to the needs of users, auditors, and regulators."
  },
  {
    "key": 141,
    "value": "External output filter",
    "description": "A post-processing mechanism that scans model outputs to remove restricted or harmful content."
  },
  {
    "key": 142,
    "value": "Fact-validation audit",
    "description": "An audit that checks whether the facts and references provided by an AI system are authentic, current, and correct."
  },
  {
    "key": 143,
    "value": "Fairness (responsible AI)",
    "description": "Ensuring that an AI system treats users equitably by identifying and reducing harmful biases in data, design, and model outputs."
  },
  {
    "key": 144,
    "value": "Feature masking",
    "description": "The hiding of data fields that a model does not need, often used in sanitization."
  },
  {
    "key": 145,
    "value": "Feature minimization",
    "description": "Restricting model features to the least amount of personal or sensitive information required for accurate predictions."
  },
  {
    "key": 146,
    "value": "Feature store",
    "description": "A managed repository of machine-learning features with lineage, access control, and reproducibility."
  },
  {
    "key": 147,
    "value": "Federated learning",
    "description": "A decentralized machine learning approach in which models are trained across multiple devices or organizations without sharing raw data, allowing local data to remain on its source while only model updates are aggregated centrally to improve privacy, security, and regulatory compliance."
  },
  {
    "key": 148,
    "value": "Feedback and iteration",
    "description": "A life cycle phase where insights from monitoring, user reports, and audits drive updates or improvements to the system."
  },
  {
    "key": 149,
    "value": "Few-shot prompting",
    "description": "A prompting method that includes two to five examples to teach a generative model how to perform a task by demonstration."
  },
  {
    "key": 150,
    "value": "Fine-tuned backdoor",
    "description": "A hidden malicious behavior carried into a downstream model during fine-tuning of a compromised foundation model."
  },
  {
    "key": 151,
    "value": "Fine-tuning",
    "description": "A transfer learning method in which a pre-trained model is adapted to a smaller task-specific dataset to improve performance in a particular domain."
  },
  {
    "key": 152,
    "value": "Firewall rules",
    "description": "Network-level controls that limit which connections or traffic may reach a deployed AI model."
  },
  {
    "key": 153,
    "value": "Fraud detection (AI-driven)",
    "description": "The use of machine learning to identify suspicious activity by correlating unusual login, device, and transaction patterns."
  },
  {
    "key": 154,
    "value": "FraudGPT",
    "description": "An underground AI model used to generate phishing messages, malicious scripts, and other cybercrime tools."
  },
  {
    "key": 155,
    "value": "GAN (generative adversarial network)",
    "description": "A generative model consisting of a generator and a discriminator that improves through adversarial training to produce realistic synthetic content."
  },
  {
    "key": 156,
    "value": "GAN-generated evasion",
    "description": "The use of GANs to produce images, audio, or text that are purposely designed to bypass detection models."
  },
  {
    "key": 157,
    "value": "Gateway controls",
    "description": "Security layers applied at interfaces such as APIs or web front-ends to validate inputs, enforce limits, and restrict access."
  },
  {
    "key": 158,
    "value": "GDPR (General Data Protection Regulation)",
    "description": "A European Union data protection law that governs how organizations collect, store, process, and transfer personal data, emphasizing transparency, user rights, data minimization, and strong security controls."
  },
  {
    "key": 159,
    "value": "Generative AI",
    "description": "A category of AI models that create new content such as text, images, or synthetic security data based on learned patterns."
  },
  {
    "key": 160,
    "value": "Generator (GAN)",
    "description": "The model in a generative adversarial network that produces synthetic samples designed to resemble real data."
  },
  {
    "key": 161,
    "value": "Governance framework (AI)",
    "description": "The combination of policies, standards, procedures, and guidelines that define how AI must be built, evaluated, and operated."
  },
  {
    "key": 162,
    "value": "GPU (graphics processing unit)",
    "description": "A processor optimized for parallel computation, widely used for training large AI models."
  },
  {
    "key": 163,
    "value": "GRC (Governance, Risk, and Compliance)",
    "description": "A strategy for managing organizational policies, risk controls, and regulatory obligations."
  },
  {
    "key": 164,
    "value": "Guardrail circumvention",
    "description": "An attack that bypasses the protective constraints placed around an AI system without modifying the model itself."
  },
  {
    "key": 165,
    "value": "Hallucination",
    "description": "An AI model-generated output that appears plausible but is factually incorrect or fabricated."
  },
  {
    "key": 166,
    "value": "Hallucination rate",
    "description": "A quantitative measure of how often an AI system produces fabricated or unsupported content."
  },
  {
    "key": 167,
    "value": "Hashing",
    "description": "The use of a one-way function to generate a fixed-size output used for integrity checks."
  },
  {
    "key": 168,
    "value": "HIPAA (Health Insurance Portability and Accountability Act)",
    "description": "A U.S. law that sets privacy and security requirements for the handling of protected health information by healthcare organizations, insurers, and their business partners."
  },
  {
    "key": 169,
    "value": "Homomorphic encryption",
    "description": "A cryptographic method that allows computations on encrypted data without decrypting it."
  },
  {
    "key": 170,
    "value": "Honeypot",
    "description": "A decoy system intentionally deployed to attract attackers and collect intelligence about their behaviors."
  },
  {
    "key": 171,
    "value": "Honeypot data analysis",
    "description": "The use of AI to process and summarize data collected from compromised honeypots, in order to reveal attacker tactics."
  },
  {
    "key": 172,
    "value": "Honeypot detection (AI-assisted)",
    "description": "The use of models to identify decoy systems by analyzing patterns in banners, timing, fingerprints, or service responses."
  },
  {
    "key": 173,
    "value": "HTTPS (Hypertext Transfer Protocol Secure)",
    "description": "An encrypted protocol for securely transferring data between a browser and web server."
  },
  {
    "key": 174,
    "value": "Hub-and-spoke model",
    "description": "An organizational structure where a central CoE provides standards and oversight (hub) while business units build and operate solutions (spokes)."
  },
  {
    "key": 175,
    "value": "Human oversight",
    "description": "System-level supervision where humans monitor AI behavior and intervene when necessary."
  },
  {
    "key": 176,
    "value": "Human validation",
    "description": "Post-decision review of AI outputs to identify patterns of error, bias, or unexpected behavior."
  },
  {
    "key": 177,
    "value": "Human-in-the-loop",
    "description": "A control requiring a human to review, approve, or override AI suggestions or actions in higher-risk situations."
  },
  {
    "key": 178,
    "value": "Hyper-realistic synthetic identity (AI badge)",
    "description": "A falsified identification badge or credential generated by AI to bypass physical security checks."
  },
  {
    "key": 179,
    "value": "IaC (Infrastructure as Code)",
    "description": "A method of provisioning and managing infrastructure through machine-readable configuration files."
  },
  {
    "key": 180,
    "value": "IAM (Identity and Access Management)",
    "description": "A framework that manages user identities, authentication, and authorization."
  },
  {
    "key": 181,
    "value": "IDE (integrated development environment)",
    "description": "A software suite that provides coding, debugging, and testing tools in one interface."
  },
  {
    "key": 182,
    "value": "IDE plug-in (AI-enabled)",
    "description": "An AI-enabled extension for integrated development environments (IDEs) that provides autocomplete, code correction, and security recommendations."
  },
  {
    "key": 183,
    "value": "IdP (identity provider)",
    "description": "A service that authenticates users and issues identity information to applications."
  },
  {
    "key": 184,
    "value": "IDS (intrusion detection system)",
    "description": "A security tool that monitors networks or systems for malicious activity or policy violations."
  },
  {
    "key": 185,
    "value": "Impersonation (AI-driven)",
    "description": "Mimicking a person’s appearance, voice, writing style, or communication behavior using generative AI models."
  },
  {
    "key": 186,
    "value": "Incident response automation",
    "description": "The use of AI to enrich alerts, correlate events, recommend containment steps, and autopopulate incident tickets."
  },
  {
    "key": 187,
    "value": "Incident response ticket management",
    "description": "AI-powered creation, merging, updating, and summarization of incident tickets based on logs and alerts."
  },
  {
    "key": 188,
    "value": "Inclusiveness (responsible AI)",
    "description": "Designing AI so it works for people across abilities, languages, cultures, and environments."
  },
  {
    "key": 189,
    "value": "Indirect prompt injection",
    "description": "A method of hiding malicious instructions inside external content such as documents or web pages processed by the model."
  },
  {
    "key": 190,
    "value": "Insecure output handling",
    "description": "The unsafe assumption that model-generated content is trustworthy, which can lead to execution, rendering, or storage of harmful output."
  },
  {
    "key": 191,
    "value": "Insecure plug-in design",
    "description": "A flaw in external integrations where AI-generated instructions can cause unauthorized actions through connected tools or APIs."
  },
  {
    "key": 192,
    "value": "Input manipulation",
    "description": "Crafting inputs designed to mislead a model into incorrect interpretation or classification."
  },
  {
    "key": 193,
    "value": "Input monitoring",
    "description": "The practice of logging, reviewing, and analyzing user prompts to detect malicious or inappropriate inputs."
  },
  {
    "key": 194,
    "value": "Input validation",
    "description": "A security measure that checks incoming data to ensure it is well-formed, safe, and expected before model processing."
  },
  {
    "key": 195,
    "value": "Integrity checks",
    "description": "Processes that detect unauthorized alterations to data or model components using hashes, signatures, or other mechanisms."
  },
  {
    "key": 196,
    "value": "Intellectual-property risk (IP risk)",
    "description": "Legal exposure caused by using copyrighted or proprietary data in training or by generating outputs that resemble protected content."
  },
  {
    "key": 197,
    "value": "IP (intellectual property)",
    "description": "Ideas, inventions, or creative works that are legally protected."
  },
  {
    "key": 198,
    "value": "ISO (International Organization for Standardization)",
    "description": "An international body that develops globally recognized technical and industry standards."
  },
  {
    "key": 199,
    "value": "ITIL (Information Technology Infrastructure Library)",
    "description": "A framework for IT service management focused on aligning IT services with business needs."
  },
  {
    "key": 200,
    "value": "ITSM (Information Technology Service Management)",
    "description": "A set of practices for delivering and managing IT services effectively."
  },
  {
    "key": 201,
    "value": "Jailbreak testing",
    "description": "A security evaluation practice that probes an AI system with adversarial prompts to test whether guardrails can be bypassed."
  },
  {
    "key": 202,
    "value": "Jailbreaking",
    "description": "A targeted prompt-based attack that overrides a model’s safety controls to elicit prohibited content or actions."
  },
  {
    "key": 203,
    "value": "JSON (JavaScript Object Notation)",
    "description": "A lightweight, human-readable data format used for structured data exchange, commonly used in APIs, logs, and model inputs."
  },
  {
    "key": 204,
    "value": "Key management",
    "description": "The secure handling, storage, and rotation of sensitive credentials such as API keys and encryption keys."
  },
  {
    "key": 205,
    "value": "Key rotation",
    "description": "Regular replacement of API keys, encryption keys, or tokens to reduce the impact of credential compromise."
  },
  {
    "key": 206,
    "value": "Knowledge store (vector store)",
    "description": "A specialized database used in RAG systems to store embeddings based on geometric similarity and supports semantic search."
  },
  {
    "key": 207,
    "value": "Label (supervised learning)",
    "description": "The correct output paired with each training example in a supervised dataset."
  },
  {
    "key": 208,
    "value": "LAN (local area network)",
    "description": "A network that connects devices within a limited area such as a building."
  },
  {
    "key": 209,
    "value": "LDAP (Lightweight Directory Access Protocol)",
    "description": "A protocol used to query and manage directory services such as user accounts."
  },
  {
    "key": 210,
    "value": "Leakage",
    "description": "See: Data leakage."
  },
  {
    "key": 211,
    "value": "Least privilege",
    "description": "A security principle ensuring users or integrated components have only the minimal access necessary for their role."
  },
  {
    "key": 212,
    "value": "Limited-risk AI system (EU AI Act)",
    "description": "A system that must disclose AI involvement to users but faces fewer requirements than high-risk systems."
  },
  {
    "key": 213,
    "value": "Linting (AI-assisted)",
    "description": "Automated code review that flags errors, inconsistencies, and insecure patterns beyond traditional rule-based linters."
  },
  {
    "key": 214,
    "value": "LLM (large language model)",
    "description": "A transformer-based model with hundreds of millions to billions of parameters that can generate, summarize, or analyze text across many domains."
  },
  {
    "key": 215,
    "value": "Log access monitoring",
    "description": "Tracking who queries or retrieves log records to detect unauthorized access attempts."
  },
  {
    "key": 216,
    "value": "Log integrity protection (log protection)",
    "description": "Controls such as encryption, signatures, and append-only storage that prevent logs from being altered or deleted."
  },
  {
    "key": 217,
    "value": "Log monitoring",
    "description": "The ongoing review of system and model logs to detect suspicious activity, security anomalies, misuse attempts, or control failures."
  },
  {
    "key": 218,
    "value": "Log retention policy",
    "description": "Rules that define how long logs are stored before being archived or deleted to meet compliance and privacy requirements."
  },
  {
    "key": 219,
    "value": "Log sanitization",
    "description": "The removal or masking of sensitive information such as PII or secrets before logs are stored."
  },
  {
    "key": 220,
    "value": "Low-code automation",
    "description": "Platforms where users build workflows using minimal scripting, often enhanced by AI that writes or modifies required code blocks."
  },
  {
    "key": 221,
    "value": "Machine learning (ML)",
    "description": "A subset of AI that uses algorithms to detect patterns in data and make predictions without explicit rule-based programming."
  },
  {
    "key": 222,
    "value": "Machine learning engineer",
    "description": "A technical professional who designs, builds, deploys, and maintains systems that use machine learning models in production environments."
  },
  {
    "key": 223,
    "value": "Malicious dependency",
    "description": "A compromised library or package introduced into the AI pipeline that enables unauthorized manipulation or access."
  },
  {
    "key": 224,
    "value": "Masking",
    "description": "See: Data masking."
  },
  {
    "key": 225,
    "value": "MCP (Model Context Protocol)",
    "description": "A protocol that standardizes how models receive context, tools, and memory for safer AI interaction."
  },
  {
    "key": 226,
    "value": "MDLC (Model Development Life Cycle)",
    "description": "The sequence of stages involved in developing, validating, deploying, and maintaining AI models."
  },
  {
    "key": 227,
    "value": "Membership inference",
    "description": "An attack that determines whether specific data samples were part of a model’s training set."
  },
  {
    "key": 228,
    "value": "Metadata sanitization",
    "description": "The removal of sensitive contextual details such as timestamps or sender information from semi-structured data."
  },
  {
    "key": 229,
    "value": "Misinformation",
    "description": "False or altered content shared unintentionally by people who believe it is real."
  },
  {
    "key": 230,
    "value": "Minimal-risk AI system (EU AI Act)",
    "description": "A system with negligible safety concerns, such as spam filters or AI-assisted games, with no mandatory regulatory requirements."
  },
  {
    "key": 231,
    "value": "MIT (Massachusetts Institute of Technology)",
    "description": "A research university in the United States known for its significant contributions to the fields of computing, engineering, and AI."
  },
  {
    "key": 232,
    "value": "MITRE (MITRE Corporation)",
    "description": "A nonprofit research organization that operates federally funded research and development centers to develop public-interest frameworks, standards, and security knowledge bases used across government and industry."
  },
  {
    "key": 233,
    "value": "ML (machine learning)",
    "description": "See: Machine learning."
  },
  {
    "key": 234,
    "value": "MLOps (Machine Learning Operations)",
    "description": "Practices for deploying, monitoring, and maintaining ML models at scale."
  },
  {
    "key": 235,
    "value": "Modality limits",
    "description": "Restrictions that determine which input types such as text, images, or audio a system will accept."
  },
  {
    "key": 236,
    "value": "Model access controls",
    "description": "Measures that restrict who can run, configure, fine-tune, or export a model."
  },
  {
    "key": 237,
    "value": "Model card",
    "description": "A documentation artifact describing a model’s intended use, metrics, limitations, and known risks."
  },
  {
    "key": 238,
    "value": "Model confidence threshold",
    "description": "A predefined minimum confidence level required before an AI system can act autonomously."
  },
  {
    "key": 239,
    "value": "Model deployment",
    "description": "The phase in which a trained model is integrated into a production system for live use."
  },
  {
    "key": 240,
    "value": "Model drift",
    "description": "Performance degradation that occurs when real-world input patterns shift away from the original training distribution."
  },
  {
    "key": 241,
    "value": "Model-driven intrusion chain",
    "description": "A multistep attack sequence coordinated by an AI agent that automatically chooses each next action."
  },
  {
    "key": 242,
    "value": "Model evaluation",
    "description": "The assessment of model accuracy and behavior using unseen data to determine readiness for deployment."
  },
  {
    "key": 243,
    "value": "Model evaluation (vulnerability and compliance)",
    "description": "A structured assessment that tests a model for vulnerabilities, bias, robustness, and compliance before deployment."
  },
  {
    "key": 244,
    "value": "Model fingerprinting",
    "description": "A technique used to identify and prove ownership of a model based on unique behavioral traits."
  },
  {
    "key": 245,
    "value": "Model guardrails",
    "description": "Model-level protections that limit harmful outputs, enforce policy boundaries, and block unsafe behaviors."
  },
  {
    "key": 246,
    "value": "Model inversion",
    "description": "An attack that extracts sensitive data or attributes from a trained model through targeted queries."
  },
  {
    "key": 247,
    "value": "Model poisoning",
    "description": "A direct manipulation of a model’s weights or architecture, often through a compromised pretrained foundation model."
  },
  {
    "key": 248,
    "value": "Model protection",
    "description": "Defensive practices such as encryption, watermarking, and secure enclaves used to prevent model theft or tampering."
  },
  {
    "key": 249,
    "value": "Model skewing",
    "description": "A gradual manipulation of model behavior through biased interaction or feedback loops that shift outputs over time."
  },
  {
    "key": 250,
    "value": "Model theft",
    "description": "The illicit replication of a model, achieved either through direct access to model files or repeated remote queries."
  },
  {
    "key": 251,
    "value": "Model watermarking",
    "description": "Embedding a hidden identifier into a model’s behavior or outputs to support intellectual property protection."
  },
  {
    "key": 252,
    "value": "Model validation",
    "description": "The process of evaluating a trained model on unseen data to confirm that it generalizes beyond the training set."
  },
  {
    "key": 253,
    "value": "Monitoring prompts and responses",
    "description": "A security practice that reviews both inputs and outputs to detect misuse, leaks, and unsafe model behavior."
  },
  {
    "key": 254,
    "value": "Monitoring rate limits",
    "description": "Tracking request volume over time to detect unusual spikes or declines that may indicate attacks or client errors."
  },
  {
    "key": 255,
    "value": "MSSP (Managed Security Service Provider)",
    "description": "A third-party service that operates security monitoring and threat response for organizations."
  },
  {
    "key": 256,
    "value": "Multishot prompting",
    "description": "A prompting approach that uses more than a few examples to reinforce patterns for complex tasks."
  },
  {
    "key": 257,
    "value": "NACL (Network Access Control List)",
    "description": "A network filter applied at the subnet layer that allows or denies specific inbound or outbound traffic."
  },
  {
    "key": 258,
    "value": "Network isolation",
    "description": "The protection of AI systems by placing them in restricted network zones and controlling inbound and outbound traffic."
  },
  {
    "key": 259,
    "value": "Neural network",
    "description": "A computational model composed of interconnected layers of nodes that learn patterns from data by adjusting weighted connections during training."
  },
  {
    "key": 260,
    "value": "NIST (National Institute of Standards and Technology)",
    "description": "A U.S. standards and research agency that develops technical frameworks, measurement methods, security guidelines, and best practices used to improve reliability, safety, and risk management across digital and AI systems."
  },
  {
    "key": 261,
    "value": "NIST AI Risk Management Framework (AI RMF)",
    "description": "A voluntary framework structured around the Govern, Map, Measure, and Manage functions for AI risk control."
  },
  {
    "key": 262,
    "value": "NLP (Natural language processing)",
    "description": "A field of AI focused on enabling computers to interpret, analyze, and generate human language."
  },
  {
    "key": 263,
    "value": "No-code automation",
    "description": "Automation platforms that use visual or natural-language interfaces instead of scripting, often assisted by AI for workflow creation."
  },
  {
    "key": 264,
    "value": "OAuth (Open Authorization)",
    "description": "A protocol that allows secure delegated access to resources without sharing passwords."
  },
  {
    "key": 265,
    "value": "Obfuscation (AI-assisted)",
    "description": "Automatically mutating or disguising malware, macros, or commands so security tools cannot recognize them."
  },
  {
    "key": 266,
    "value": "OECD (Organisation for Economic Co-operation and Development)",
    "description": "An international organization that creates policy standards, research guidance, and cooperative initiatives to support responsible technology development, economic growth, and cross-border governance, including principles for trustworthy AI."
  },
  {
    "key": 267,
    "value": "OECD AI principles",
    "description": "International guidelines focused on transparency, robustness, fairness, human rights, and accountability."
  },
  {
    "key": 268,
    "value": "On-demand exploit generation",
    "description": "The use of an LLM to create or adapt exploit code for a discovered vulnerability."
  },
  {
    "key": 269,
    "value": "OSINT (Open Source Intelligence)",
    "description": "Information gathered from publicly available sources such as websites, social media, publications, and public records for investigative or analytical purposes."
  },
  {
    "key": 270,
    "value": "Outcome disparity",
    "description": "A measurable difference in model results across demographic groups that indicates fairness concerns."
  },
  {
    "key": 271,
    "value": "Output filtering",
    "description": "A post-processing step that removes harmful, restricted, or sensitive content from AI responses."
  },
  {
    "key": 272,
    "value": "Output integrity attack",
    "description": "A manipulation of the model’s output after inference through wrappers, middleware, or other external components."
  },
  {
    "key": 273,
    "value": "Output minimization",
    "description": "The practice of limiting AI outputs to only the information needed for the task, which reduces exposure of sensitive details."
  },
  {
    "key": 274,
    "value": "Output monitoring (response monitoring)",
    "description": "The review and analysis of model-generated responses to detect harmful content, policy violations, sensitive data leakage, or abnormal behavior."
  },
  {
    "key": 275,
    "value": "Overfitting",
    "description": "A model training problem in which the model learns specific details of the training data rather than general patterns, which causes poor performance on new data."
  },
  {
    "key": 276,
    "value": "Overreliance",
    "description": "A human behavioral failure where users trust model output without verification."
  },
  {
    "key": 277,
    "value": "Oversampling",
    "description": "Increasing the number of minority class samples to reduce class imbalance."
  },
  {
    "key": 278,
    "value": "OWASP (Open Worldwide Application Security Project)",
    "description": "A global nonprofit community that produces widely used security guidelines, testing methodologies, and risk lists for application and AI system security, designed to help organizations identify and mitigate emerging vulnerabilities."
  },
  {
    "key": 279,
    "value": "OWASP LLM Top Ten",
    "description": "A list of the most critical risks associated with large language models, including prompt injection, sensitive data disclosure, and excessive agency."
  },
  {
    "key": 280,
    "value": "OWASP ML Top Ten",
    "description": "A list of high-impact vulnerabilities affecting traditional machine learning systems, such as data poisoning and model inversion."
  },
  {
    "key": 281,
    "value": "Pattern recognition",
    "description": "The use of AI to identify relationships or coordinated behavior across large datasets that would be difficult for humans to detect."
  },
  {
    "key": 282,
    "value": "Payload generation (AI)",
    "description": "Creating attack payloads that incorporate obfuscation, anti-debugging, or environment checks automatically."
  },
  {
    "key": 283,
    "value": "Payload size limits",
    "description": "Restrictions that cap the size of inputs submitted to an AI system to prevent resource exhaustion or hidden malicious content."
  },
  {
    "key": 284,
    "value": "PCI DSS (Payment Card Industry Data Security Standard)",
    "description": "An international security standard that defines technical and operational requirements for protecting cardholder data across payment systems, including encryption, access control, monitoring, and secure network practices."
  },
  {
    "key": 285,
    "value": "PentestGPT",
    "description": "A penetration-testing agent that interprets scanner output, identifies weaknesses, and suggests or generates exploits."
  },
  {
    "key": 286,
    "value": "Personal assistant (AI)",
    "description": "See: AI personal assistant."
  },
  {
    "key": 287,
    "value": "Persistent context attack",
    "description": "A technique that plants malicious instructions in stored memory, session history, or documents for later execution."
  },
  {
    "key": 288,
    "value": "PII (personally identifiable information)",
    "description": "Information that can identify an individual either directly, such as a name or ID number, or indirectly when combined with other data."
  },
  {
    "key": 289,
    "value": "PII masking (log sanitization)",
    "description": "Masking or hashing personally identifiable information before logs are written or indexed."
  },
  {
    "key": 290,
    "value": "PII redaction",
    "description": "The automated removal of personally identifiable information before logging or returning outputs."
  },
  {
    "key": 291,
    "value": "Planning and business alignment",
    "description": "The life cycle phase where use cases, requirements, risks, and constraints are defined."
  },
  {
    "key": 292,
    "value": "Plug-in exploitation",
    "description": "The use of insecure AI integrations to trigger unauthorized external system actions."
  },
  {
    "key": 293,
    "value": "Policy",
    "description": "A mandatory, organization-wide rule stating what is permitted, prohibited, and required for AI development and use."
  },
  {
    "key": 294,
    "value": "Policy-based blocking",
    "description": "Enforcement of regulatory or organizational rules such as GDPR, HIPAA, or PCI-DSS in prompts or outputs."
  },
  {
    "key": 295,
    "value": "Polymorphic attack workflow",
    "description": "An AI-driven process in which every run creates a unique variant of an attack to evade signature detection."
  },
  {
    "key": 296,
    "value": "Polymorphic malware",
    "description": "Malicious software that frequently changes its structure or appearance to evade traditional signature-based detection."
  },
  {
    "key": 297,
    "value": "Privacy-preserving data preparation",
    "description": "Techniques such as masking, tokenization, and anonymization used to protect sensitive information."
  },
  {
    "key": 298,
    "value": "Prohibited practice (EU AI Act)",
    "description": "An AI use case banned outright, such as social scoring or exploitative manipulation of vulnerable groups."
  },
  {
    "key": 299,
    "value": "Prompt engineering",
    "description": "The process of crafting inputs to a generative AI model to obtain accurate, relevant, and well-structured outputs."
  },
  {
    "key": 300,
    "value": "Prompt firewall",
    "description": "A defensive tool that filters, monitors, or rewrites user prompts to block malicious or unsafe inputs before reaching the model."
  },
  {
    "key": 301,
    "value": "Prompt injection",
    "description": "A manipulation that embeds malicious instructions to override or alter a model’s behavior."
  },
  {
    "key": 302,
    "value": "Prompt injection detection",
    "description": "The practice of scanning prompts for hidden or malicious instructions that attempt to bypass safeguards."
  },
  {
    "key": 303,
    "value": "Prompt monitoring",
    "description": "See: Input monitoring."
  },
  {
    "key": 304,
    "value": "Prompt roles",
    "description": "The system, user, and assistant roles that structure interactions in conversational AI systems."
  },
  {
    "key": 305,
    "value": "Prompt template",
    "description": "A structured prompt with fixed system instructions and a defined slot for user input that reduces prompt injection risk."
  },
  {
    "key": 306,
    "value": "Pruning",
    "description": "A model optimization technique that removes unnecessary neural network weights or connections to reduce size and improve efficiency."
  },
  {
    "key": 307,
    "value": "Pseudonymization",
    "description": "A technique that replaces direct identifiers with consistent fictitious labels while preserving relationships within the dataset."
  },
  {
    "key": 308,
    "value": "Push-button phishing",
    "description": "The generation of highly personalized phishing emails from a few keywords or context fragments using generative models."
  },
  {
    "key": 309,
    "value": "Push-style reconnaissance (LLM-driven)",
    "description": "Automated gathering and summarization of OSINT or leaked data to map targets."
  },
  {
    "key": 310,
    "value": "Quantization",
    "description": "A model optimization method that reduces numerical precision, such as converting 32-bit values to 8-bit, to improve speed and reduce memory use."
  },
  {
    "key": 311,
    "value": "Quotas",
    "description": "Limits on the volume of requests, tokens, or resources a user or system can consume within a defined period."
  },
  {
    "key": 312,
    "value": "RAG (retrieval-augmented generation)",
    "description": "A method that combines generative models with external knowledge retrieval to improve accuracy."
  },
  {
    "key": 313,
    "value": "RAG auditing",
    "description": "A review that verifies whether retrieval-augmented generation outputs align with retrieved documents and whether the knowledge base is current and accurate."
  },
  {
    "key": 314,
    "value": "Rate limiting",
    "description": "A control that caps how many requests or tokens a user or system can consume within a defined time window."
  },
  {
    "key": 315,
    "value": "Rate monitoring",
    "description": "Tracking the frequency and volume of AI requests over time to detect anomalies, prevent abuse, and support load management."
  },
  {
    "key": 316,
    "value": "RBAC (role-based access control)",
    "description": "A permission model that assigns capabilities based on job roles."
  },
  {
    "key": 317,
    "value": "Red team exercise (red team testing)",
    "description": "A security test in which specialists attempt to deceive or break a model to expose vulnerabilities."
  },
  {
    "key": 318,
    "value": "Regression",
    "description": "A supervised learning task that predicts continuous numeric values."
  },
  {
    "key": 319,
    "value": "Regression testing (AI-optimized)",
    "description": "Selecting the most relevant tests to run based on recent code changes using test-impact analysis."
  },
  {
    "key": 320,
    "value": "Reinforcement learning (RL)",
    "description": "A machine learning method where an agent interacts with an environment and learns policies through reward-based feedback."
  },
  {
    "key": 321,
    "value": "Reinforcement-driven exploitation",
    "description": "The use of reinforcement-learning agents to optimize attack paths or exploit sequences through trial-and-error simulations."
  },
  {
    "key": 322,
    "value": "Reliability and safety",
    "description": "The responsible AI principle that ensures systems meet performance targets and behave safely under normal and adverse conditions."
  },
  {
    "key": 323,
    "value": "Reputational risk",
    "description": "Potential harm to public trust or brand credibility caused by AI failures such as toxic outputs, unfair outcomes, or misleading behavior."
  },
  {
    "key": 324,
    "value": "Response monitoring",
    "description": "See: Output monitoring."
  },
  {
    "key": 325,
    "value": "Response tuning",
    "description": "Adjustments that train or configure a model to provide safer outputs or refuse restricted queries."
  },
  {
    "key": 326,
    "value": "Retention minimization",
    "description": "The practice of deleting logs or prompts after an approved period to reduce privacy and compliance risks."
  },
  {
    "key": 327,
    "value": "Risk register",
    "description": "A living document that tracks identified AI risks, mitigations, residual risk, and ownership."
  },
  {
    "key": 328,
    "value": "RMF (Risk Management Framework)",
    "description": "A structured approach for managing risks through identification, assessment, and mitigation."
  },
  {
    "key": 329,
    "value": "Rule-based system",
    "description": "A traditional cybersecurity method that relies on predefined logic and signatures instead of learned patterns."
  },
  {
    "key": 330,
    "value": "Sanctioned vs. unsanctioned tools",
    "description": "A corporate policy distinction that identifies which AI tools are approved for use and which are prohibited."
  },
  {
    "key": 331,
    "value": "Sanity check",
    "description": "A validation step that verifies model outputs fall within expected boundaries."
  },
  {
    "key": 332,
    "value": "Sarcasm evasion attack",
    "description": "A form of input manipulation that exploits a model’s inability to detect sarcasm or tone."
  },
  {
    "key": 333,
    "value": "SCA (software composition analysis)",
    "description": "A method for identifying vulnerabilities in third-party libraries and dependencies."
  },
  {
    "key": 334,
    "value": "Schema enforcement",
    "description": "Validation that incoming data conforms to the required structure, such as JSON or XML, before being processed."
  },
  {
    "key": 335,
    "value": "SDLC (Software Development Life Cycle)",
    "description": "The structured process for planning, creating, testing, and deploying software."
  },
  {
    "key": 336,
    "value": "Secure enclave",
    "description": "A hardware-based protected execution environment designed to prevent tampering and unauthorized access to models."
  },
  {
    "key": 337,
    "value": "Secure integration",
    "description": "Validation of inputs and outputs at the system boundary to prevent malicious content from reaching or leaving a model."
  },
  {
    "key": 338,
    "value": "Segregation of duties",
    "description": "A governance principle ensuring that no single user can perform highrisk actions without oversight."
  },
  {
    "key": 339,
    "value": "Semi-structured data",
    "description": "Data with some organizational markers such as tags or metadata, including formats like JSON, XML, or log files."
  },
  {
    "key": 340,
    "value": "Sensitive data tags",
    "description": "Labels applied to outputs to indicate confidentiality requirements or restrictions on sharing."
  },
  {
    "key": 341,
    "value": "Sensitive information disclosure",
    "description": "The unintentional return of private, proprietary, or confidential data during inference."
  },
  {
    "key": 342,
    "value": "SIEM (Security Information and Event Management)",
    "description": "A platform that aggregates prompts, responses, logs, and security events to detect threats and support compliance monitoring."
  },
  {
    "key": 343,
    "value": "Signature matching (AI-assisted)",
    "description": "Comparing artifacts against known malicious indicators and generating new detection signatures based on emerging threats."
  },
  {
    "key": 344,
    "value": "SLM (small language model)",
    "description": "A model with fewer parameters than an LLM, often domainspecific and suitable for local or edge deployment."
  },
  {
    "key": 345,
    "value": "SOAR (Security Orchestration, Automation, and Response)",
    "description": "A system that coordinates security tools and automates incident response workflows."
  },
  {
    "key": 346,
    "value": "SOC (Security Operations Center)",
    "description": "A team and facility responsible for monitoring, detecting, and responding to cyberthreats."
  },
  {
    "key": 347,
    "value": "SOC 2 (System and Organization Controls 2)",
    "description": "A standard for evaluating security, availability, confidentiality, processing integrity, and privacy controls."
  },
  {
    "key": 348,
    "value": "Social-engineering automation",
    "description": "AI-generated phishing, vishing, chat-based scams, and synthetic conversational fraud that mimic trusted communication patterns."
  },
  {
    "key": 349,
    "value": "Software composition analysis (AI-enhanced)",
    "description": "AI-driven evaluation of third-party libraries that prioritizes vulnerabilities based on usage, exploitability, and compatibility."
  },
  {
    "key": 350,
    "value": "SQL (Structured Query Language)",
    "description": "A language used to manage and query relational databases."
  },
  {
    "key": 351,
    "value": "SSH (Secure Shell)",
    "description": "A protocol for secure command-line access to remote systems."
  },
  {
    "key": 352,
    "value": "Steganographic command channel",
    "description": "Hidden attacker instructions embedded in images or other media using AI-based steganographic methods."
  },
  {
    "key": 353,
    "value": "Structured data",
    "description": "Well-defined data organized in tables or fixed schemas."
  },
  {
    "key": 354,
    "value": "Supervised learning",
    "description": "A machine learning approach in which models learn from labeled datasets to perform classification or regression tasks."
  },
  {
    "key": 355,
    "value": "System card",
    "description": "Documentation outlining an AI system’s design, data flows, risks, and operational behavior."
  },
  {
    "key": 356,
    "value": "System prompt leakage",
    "description": "The exposure of internal configuration or safety rules through crafted prompts."
  },
  {
    "key": 357,
    "value": "System role",
    "description": "The prompt role that sets rules, tone, and behavior for a conversational AI model. See also: Prompt roles."
  },
  {
    "key": 358,
    "value": "Tailored phishing (AI-generated)",
    "description": "Personalized phishing messages crafted using AI-analyzed victim data such as job roles, internal terminology, or leaked emails."
  },
  {
    "key": 359,
    "value": "TEE (trusted execution environment)",
    "description": "A secure environment that executes code and processes encrypted data in isolation from the host system."
  },
  {
    "key": 360,
    "value": "Third-party compliance evaluation",
    "description": "An external audit or assessment that verifies the effectiveness of controls, documentation, and governance practices."
  },
  {
    "key": 361,
    "value": "Threat modeling",
    "description": "A structured analysis used to identify AI assets, adversaries, vulnerabilities, and attack paths."
  },
  {
    "key": 362,
    "value": "Threat modeling assistance",
    "description": "AI-driven identification of potential attack vectors and recommended controls based on system architecture and threat intelligence."
  },
  {
    "key": 363,
    "value": "Throttling",
    "description": "A control that slows or temporarily stops processing when system load becomes unstable."
  },
  {
    "key": 364,
    "value": "TLS (Transport Layer Security)",
    "description": "A cryptographic protocol that encrypts network communications for confidentiality and integrity."
  },
  {
    "key": 365,
    "value": "Token-based rate limiting",
    "description": "A quota system that restricts token consumption over time rather than simple request counts."
  },
  {
    "key": 366,
    "value": "Token usage monitoring",
    "description": "Tracking input and output token consumption to manage costs and detect unusual activity."
  },
  {
    "key": 367,
    "value": "Tokenization",
    "description": "Replacing sensitive data elements with nonsensitive tokens that preserve relationships but not original values."
  },
  {
    "key": 368,
    "value": "Training environment",
    "description": "The controlled, secured infrastructure used to train AI models."
  },
  {
    "key": 369,
    "value": "Transfer learning",
    "description": "A technique in which a model trained on a large dataset is adapted to a specialized task with less data through fine-tuning."
  },
  {
    "key": 370,
    "value": "Transfer learning attack",
    "description": "An attack where a compromised pretrained model carries forward hidden vulnerabilities or backdoors into downstream fine-tuned versions."
  },
  {
    "key": 371,
    "value": "Transformer",
    "description": "A neural network architecture that uses self-attention to process sequences of data efficiently and in parallel."
  },
  {
    "key": 372,
    "value": "Transparency (responsible AI)",
    "description": "Clearly informing users when AI is involved, how it works, which data it uses, and what its limitations are."
  },
  {
    "key": 373,
    "value": "Trojan attack",
    "description": "An attack that introduces a compromised AI artifact such as a pretrained model, adapter, plug-in, or dependency that behaves as expected most of the time but contains concealed malicious functionality that can be activated later."
  },
  {
    "key": 374,
    "value": "Trustworthiness (data)",
    "description": "The measure of whether data is reliable, verified, and appropriate for AI training."
  },
  {
    "key": 375,
    "value": "Unbounded consumption",
    "description": "A resource exhaustion condition where a model processes excessively large or complex inputs, leading to degraded performance or denial of service."
  },
  {
    "key": 376,
    "value": "Uncertainty (AI risk dimension)",
    "description": "The extent to which data quality, model behavior, or real-world conditions are not yet understood."
  },
  {
    "key": 377,
    "value": "Undersampling",
    "description": "Reducing the number of majority class samples to balance dataset distribution."
  },
  {
    "key": 378,
    "value": "Unit test generation (AI-driven)",
    "description": "Automatically producing normal-case and edge-case tests to validate new code functions."
  },
  {
    "key": 379,
    "value": "Unstructured data",
    "description": "Information without a predefined schema such as images, audio, or freetext documents."
  },
  {
    "key": 380,
    "value": "Unsupervised learning",
    "description": "A machine learning approach that identifies patterns or structures in unlabeled data, often used for anomaly detection."
  },
  {
    "key": 381,
    "value": "Usage attribution",
    "description": "The assignment of AI consumption or cost to specific users, teams, or applications for accountability."
  },
  {
    "key": 382,
    "value": "Usage limits",
    "description": "Restrictions on how much an AI model or agent can be used, enforced per user, role, or API key."
  },
  {
    "key": 383,
    "value": "User role",
    "description": "The prompt role that defines the task or question given directly to a generative AI model. See also: Prompt roles."
  },
  {
    "key": 384,
    "value": "Vector database",
    "description": "See: Knowledge store."
  },
  {
    "key": 385,
    "value": "Vector database encryption",
    "description": "Encryption applied to embeddings or feature vectors stored in vector databases used in AI workflows."
  },
  {
    "key": 386,
    "value": "Vector store poisoning",
    "description": "The injection of harmful or misleading content into an embedding store used by RAG-based systems."
  },
  {
    "key": 387,
    "value": "Vendor due diligence",
    "description": "The assessment process used to evaluate whether external AI tools or models meet an organization’s privacy, security, and regulatory requirements."
  },
  {
    "key": 388,
    "value": "Verification bypass (AI integrations)",
    "description": "A manipulation that causes the surrounding system to trust and execute AI-generated actions without proper authorization checks."
  },
  {
    "key": 389,
    "value": "VPC (Virtual Private Cloud)",
    "description": "A logically isolated cloud network where organizations run secure workloads."
  },
  {
    "key": 390,
    "value": "WAF (Web Application Firewall)",
    "description": "A security control that filters and monitors web application traffic to block attacks."
  },
  {
    "key": 391,
    "value": "Watermarking",
    "description": "Embedding hidden signals into datasets or AI-generated outputs to prove authenticity, detect unauthorized use, or identify leakage."
  },
  {
    "key": 392,
    "value": "XDR (Extended Detection and Response)",
    "description": "A security platform that aggregates and correlates data from endpoints, networks, cloud systems, and logs to detect complex threats and automate response actions."
  },
  {
    "key": 393,
    "value": "XML (Extensible Markup Language)",
    "description": "A markup format used to store and transport structured data with explicit tags and hierarchical organization."
  },
  {
    "key": 394,
    "value": "YARA (Yet Another Recursive Acronym)",
    "description": "A pattern-matching tool used to identify, classify, and detect malware by comparing files, memory, or code against defined rule sets."
  },
  {
    "key": 395,
    "value": "Zero-shot prompting",
    "description": "A prompting strategy where the model receives only an instruction and no examples to guide its output."
  }
];
